import dynamic from 'next/dynamic';
//loading molecules dynamically
export const SearchField = dynamic(() => import('./SearchField').then(module => module.SearchField));
export * from './PropertyCardV0';
export const UsePoints = dynamic(() => import('./UsePoints').then(module => module.UsePoints));
export const TransportationFilterComponent = dynamic(() =>
  import('./transportationFilters').then(module => module.TransportationFilterComponent)
);
export const StateFilterComponent = dynamic(() => import('./statesFilter').then(module => module.StateFilterComponent));
export const SpecialRates = dynamic(() => import('./SpecialRates').then(module => module.SpecialRates));
export const SortByFilterComponent = dynamic(() =>
  import('./sortByFilter').then(module => module.SortByFilterComponent)
);
export const SkeletonPropertyCardLoaderComponent = dynamic(() =>
  import('./skeletonPropertyCardLoader').then(module => module.SkeletonPropertyCardLoaderComponent)
);
export const SkeletonLoader = dynamic(() => import('./SkeletonLoader').then(module => module.SkeletonLoader));

export const SearchSummaryComponent = dynamic(() =>
  import('./searchResultsSummary').then(module => module.SearchSummaryComponent)
);
export const DatePicker = dynamic(() => import('./Datepicker').then(module => module.DatePicker));
export const SearchFilterPanel = dynamic(() => import('./SearchFilterPanel').then(module => module.SearchFilterPanel));
export const SaveHotelButton = dynamic(() => import('./saveHotelButton').then(module => module.SaveHotelButton));
export const RoomsAndGuests = dynamic(() => import('./RoomsAndGuests').then(module => module.RoomsAndGuests));
export const Rating = dynamic(() => import('./Rating').then(module => module.Rating));
export const QuickFiltersComponent = dynamic(() =>
  import('./quickFilters').then(module => module.QuickFiltersComponent)
);
export const PropertyImages = dynamic(() => import('./PropertyImages').then(module => module.PropertyImages));
export * from './PropertyCard';
export const PropertyCardPriceSection = dynamic(() =>
  import('./propertyCardPriceComponent').then(module => module.PropertyCardPriceSection)
);

export const PriceFilter = dynamic(() => import('./priceFilters').then(module => module.PriceFilter));
export const PointsFilter = dynamic(() => import('./pointsFilter').then(module => module.PointsFilter));
export const HotelPetPolicy = dynamic(() => import('./PetPolicy').then(module => module.HotelPetPolicy));
export const HotelParking = dynamic(() => import('./Parking').then(module => module.HotelParking));
export const PaginationSortByComponent = dynamic(() =>
  import('./paginationSortBy').then(module => module.PaginationSortByComponent)
);
export const MemberExclusiveBanner = dynamic(() =>
  import('./memberExclusiveBanner').then(module => module.MemberExclusiveBanner)
);
export const MapToolTipComponent = dynamic(() =>
  import('./mapTooltipComponent').then(module => module.MapToolTipComponent)
);
export const HotelInformation = dynamic(() => import('./LeftColumn').then(module => module.HotelInformation));
export const Layout = dynamic(() => import('./Layout').then(module => module.Layout));
export { ImageCarouselComponent } from './imageCarousel';
export const HotelTypeFilterComponent = dynamic(() =>
  import('./hotelTypeFilters').then(module => module.HotelTypeFilterComponent)
);
export const HotelsAndEvents = dynamic(() => import('./HotelsAndEvents').then(module => module.HotelsAndEvents));
export const HotelCard = dynamic(() => import('./hotelCard').then(module => module.HotelCard));
export const FiltersComponent = dynamic(() => import('./filtersComponent').then(module => module.FiltersComponent));
export const EventsFilterComponent = dynamic(() =>
  import('./eventsFilters').then(module => module.EventsFilterComponent)
);
export const ErrorHandlerAlert = dynamic(() => import('./ErrorHandlerAlert').then(module => module.ErrorHandlerAlert));
export const DistanceFilterComponent = dynamic(() =>
  import('./distanceFilters').then(module => module.DistanceFilterComponent)
);
export const Distance = dynamic(() => import('./Distance').then(module => module.Distance));
export const CityPicklist = dynamic(() => import('./CityPicklist').then(module => module.CityPicklist));
export const CityFilterComponent = dynamic(() => import('./citiesFilter').then(module => module.CityFilterComponent));
export const CarouselBullets = dynamic(() => import('./CarouselBullets').then(module => module.CarouselBullets));
export const CalendarWrapper = dynamic(() => import('./CalendarWrapper').then(module => module.CalendarWrapper));

export * from './brandFilters';
export * from './BrandFilter';
export const ShowAvailableFiltersComponent = dynamic(() =>
  import('./availabilityFilters').then(module => module.ShowAvailableFiltersComponent)
);
export const AmenitiesFilterComponent = dynamic(() =>
  import('./amenitiesFilters').then(module => module.AmenitiesFilterComponent)
);
export const AllFiltersComponent = dynamic(() => import('./allFilters').then(module => module.AllFiltersComponent));
export * from './alerts';
export const ActivitiesFilterComponent = dynamic(() =>
  import('./activitiesFilters').then(module => module.ActivitiesFilterComponent)
);
export const ActiveRibbon = dynamic(() => import('./ActiveRibbon').then(module => module.ActiveRibbon));
